import { Component, OnInit} from '@angular/core';
import { ButtonComponent } from "../../../../../components/forms/button/button.component";
import { UiTable } from "../../../../../components/ui/table/table.component";
import { TableTypeActivites } from '../../../../../data/schemas/table.schema';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { FormulaireDynamicComponent } from '../../../../../components/formulaire-dynamic/formulaire-dynamic';
import { TypeActiviteService } from '../../../../../services/typeactivites/typeactivite.service';
import { AppService } from '../../../../../core/app.service';
import { routeAlias } from '../../../../../../routesalias';
import { MatIcon } from "@angular/material/icon";
import { LoaderComponent } from "../../../../../components/ui/loader/loader.component";
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';


@Component({
  selector: 'app-typeactivities',
  imports: [UiTable, FormsModule, RouterLink, MatIcon, LoaderComponent, UiButtonComponent, ConfirmDialogComponent, loaderIntervantion],
  standalone: true,
  templateUrl: './typeactivities.component.html',
  styleUrls: ['./typeactivities.component.css']
})
export class TypeactivitiesPage implements OnInit{
  public tableTypeActivities = TableTypeActivites;
  public showAddTypeActivitiesModal: boolean = false;
  public routeAlias = routeAlias
  public isLoading: boolean = false
  public isTableLoading: boolean = true;

  public showDeleteConfirm = false;
  public selectedItem: any = null;
  public deleteLoading = false;

  constructor(private typeActiviteService: TypeActiviteService, private appService: AppService){}

  ngOnInit(): void {
    this.loadTypeActivities();
  }

  public typeActivity: string = ""
  
  public typeactitivies: any[] = [];

  loadTypeActivities(): void {
    this.isLoading = true
    this.typeActiviteService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeactitivies = response.data;
        this.isLoading =false
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
        this.isLoading =false
      }
    });
  }

  openDeleteConfirm(item: any): void {
  this.selectedItem = item;
  this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
  this.showDeleteConfirm = false;
  this.selectedItem = null;
  }

  confirmDelete(): void {
  if (!this.selectedItem) return;

  this.deleteLoading = true;

  this.typeActiviteService.delete(this.selectedItem.id).subscribe({
    next: () => {
      this.loadTypeActivities();
      this.cancelDelete();
      this.deleteLoading = false;
    },
    error: (error) => {
      console.error("Erreur suppression :", error);
      this.deleteLoading = false;
    }
  });
  }

  onDeleteTypeActivite(item: any): void {
    this.typeActiviteService.delete(item.id).subscribe(({
      next: () => {
        this.loadTypeActivities();
      },
      error: (error) => {
        console.error('Erreur lors de la création de la ligne budgétaire :', error);
        //this.isLoading = false;
      }
    }))
  }

}
